import RowActionMenu from "../../menu/RowActionMenu";
import { renderTableCell } from "../../../utils/commonfunctions";
import ChipComponent from "../../chips/ChipComponent/ChipComponent";
import { dateFormat } from "../../../utils/date";
import { getGridDateOperators } from "@mui/x-data-grid";

const dateOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
};

export default function VariablesTableFields(rowActionButtons) {
    return (
        [
            {
                field: '__check__',
                hideable: false,
                sortable: false,
                filterable: false,
                minWidth: 55,
                maxWidth: 55,
                resizable: false,
                headerAlign: 'center',
                align: 'center',
            },
            {
                field: 'key',
                headerName: "Key",
                hideable: false,
                sortable: true,
                filterable: true,
                minWidth: 150,
                maxWidth: 180,
                headerAlign: 'left',
                align: 'left',
                resizable: true,
                renderCell: (params) => renderTableCell(params.value),
            },
            {
                field: 'value',
                headerName: "Value",
                hideable: false,
                sortable: true,
                filterable: true,
                minWidth: 150,
                flex: 1,
                headerAlign: 'left',
                align: 'left',
                resizable: true,
                renderCell: (params) => renderTableCell(params.value),
            },
            {
                field: 'type',
                headerName: "Type",
                hideable: false,
                sortable: true,
                filterable: true,
                minWidth: 160,
                maxWidth: 180,
                headerAlign: 'left',
                align: 'left',
                resizable: true,
                renderCell: (params) => (
                    <ChipComponent
                        variant="default"
                        size="small"
                    >
                        {params.value}
                    </ChipComponent>
                ),
            },
            
            {
                field: 'description',
                headerName: "Description",
                hideable: true,
                sortable: true,
                filterable: true,
                minWidth: 180,
                maxWidth: 220,
                headerAlign: 'left',
                align: 'left',
                resizable: true,
                renderCell: (params) => renderTableCell(params.value),
            },
            {
                field: 'encrypted',
                headerName: "Encrypted",
                hideable: true,
                sortable: true,
                filterable: true,
                width: 130,
                headerAlign: 'left',
                align: 'left',
                resizable: false,
                renderCell: (params) => renderTableCell(params.value ? 'Yes' : 'No'),
            },
            {
                field: 'createdBy',
                headerName: "Created By",
                hideable: false,
                sortable: true,
                filterable: true,
                minWidth: 120,
                maxWidth: 150,
                headerAlign: 'left',
                align: 'left',
                resizable: true,
                renderCell: (params) => renderTableCell(params.value),
            },
            {
                field: 'createdAt',
                headerName: 'Created At',
                type: 'dateTime',
                hideable: true,
                sortable: true,
                filterable: true,
                minWidth: 120,
                maxWidth: 150,
                headerAlign: 'left',
                align: 'left',
                resizable: true,
                valueGetter: (value) => {
                    if (!value) return null;
                    return new Date(value);
                },
                valueFormatter: (value) => {
                    if (!value) return '';
                    return dateFormat(value, dateOptions);
                },
                renderCell: (params) => renderTableCell(params.formattedValue), 
                filterOperators: getGridDateOperators(),
            },
            {
                field: 'updatedBy',
                headerName: "Updated By",
                hideable: true,
                sortable: true,
                filterable: true,
                minWidth: 120,
                maxWidth: 150,
                headerAlign: 'left',
                align: 'left',
                resizable: true,
                renderCell: (params) => renderTableCell(params.value),
            },
            {
                field: 'updatedAt',
                headerName: "Updated At",
                type: 'dateTime',
                hideable: true,
                sortable: true,
                filterable: true,
                minWidth: 120,
                maxWidth: 150,
                headerAlign: 'left',
                align: 'left',
                resizable: true,
                valueGetter: (value) => {
                    if (!value) return null;
                    return new Date(value);
                },
                valueFormatter: (value) => {
                    if (!value) return '';
                    return dateFormat(value, dateOptions);
                },
                renderCell: (params) => renderTableCell(params.formattedValue), 
                filterOperators: getGridDateOperators()
            },
            {
                field: 'Actions',
                headerName: 'Actions',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                filterable: false,
                hideable: true,
                disableColumnMenu: true,
                minWidth: 90,
                maxWidth: 90,
                renderCell: (params) => (
                    <RowActionMenu 
                        menuItems={rowActionButtons} 
                        rowData={params.row} 
                        isDisabled={false}
                    />
                ),
                resizable: false, 
            },
        ] 
    )
}